import { render, staticRenderFns } from "./XAxis.vue?vue&type=template&id=572150f2&"
import script from "./XAxis.vue?vue&type=script&lang=js&"
export * from "./XAxis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports